<template>
    <div style="height: 100vh;display: flex;flex-flow: column;align-items: center;justify-content: center;">
        <!-- You might want to show a loading indicator here -->
        <img src="@/assets/img/logo.png" class="img-fluid pb-3" style="margin: auto auto 0; width: 90px;" alt="Logo">
        <span style="margin: 0 auto auto;">{{message}}</span>
    </div>
</template>
<script>
import { api } from "@/store";
export default {
  props: ['id'],
  data() {
    return {
      message: 'Traitement du paiement en cours, merci de patienter...'
    }
  },
  created() {
    this.getPaymentStatus();
  },
  methods: {
    getPaymentStatus() {
      api.post('/booking/' + this.id + '/process_payment', {
        paymentRef: this.$route.query.payment_ref,
      })
      .then(response => {
        const result = response.data
        this.message = "Succés du paiement. Redirection en cours..."
        // setTimeout(() => { window.location.replace('/booking/' + this.id + '/success') }, 5000);
        setTimeout(() => { window.location.replace('/my/bookings') }, 5000);
      })
      .catch(error => {
        alert(error.response.status)
        const result = error.response.data
        this.message = result.detail
        setTimeout(() => { window.location.replace('/my/bookings') }, 5000);
        // if (error.response.status != 402) {
        //     setTimeout(() => { window.location.replace('/my/bookings') }, 5000);
        // } else {
        //     setTimeout(() => { window.location.replace('/booking/' + this.id + '/failure') }, 5000);
        // }
      });
    },
  },
};
</script>